/**
 * 메이플스토리 캐릭터 목록 Mock 데이터
 * @type {Array<{
 *   guid: number,
 *   last_login_at: number,
 *   gc_list: Array<{
 *     gc_id: string,
 *     world_name: string,
 *     character_name: string,
 *     character_class: string,
 *     character_level: number,
 *     character_image_url: string,
 *     character_image_foot_position_y: number,
 *     collabo_item_names: Array<string>,
 *     available_actions: Array<{id: string, name: string}>,
 *     available_emotions: Array<{id: string, name: string}>,
 *     available_wmotions: Array<{id: string, name: string}>
 *   }>
 * }>}
 */
export const MOCK_CHARACTER_LISTS = [
  {
    guid: 12345678,
    last_login_at: 1710831600000, // 2024-03-19 12:00:00
    gc_list: [
      {
        gc_id: '550e8400-e29b-41d4-a716-446655440018',
        world_name: '스카니아',
        character_name: '메이플여신',
        character_class: '나이트로드',
        character_level: 230,
        character_image_url:
          'https://nxsvc.inface.nexon.com/maplestory/character/look/NGBPFLIBNBODFGOLFIJDCJPILCNNHBFONNNNBBLGPIIJJFNHDEDGEHFBJLMMENNDGNBIOPIOFNDCHJEHGEELFEENBCICKECMMBCEILJDABBNJJHINFCKEHELMHHKHPCFDABIEGMJDBOGICNBFKLIONJBEKOMEPFEGLJDAMKEPLJEFFNJNFFPEHAIBHDCIKKHHEENPHFJOIBBIANJHMCLACONGHLPOCFJGGGPGFJLFGDPPJAMHDEJLGBGCDNLNNGA?width=300&height=300',
        avatar_bottom_y: 193,
        collabo_item_names: ['BT21 쿠키 모자', '카카오프렌즈 망토', '귀멸의 칼날 탄지로 의상세트'],
        available_actions: [
          { id: 'A01', name: '걷기' },
          { id: 'A02', name: '달리기' },
          { id: 'A03', name: '점프' },
          { id: 'A04', name: '앉기' },
          { id: 'A05', name: '포탈' },
        ],
        available_emotions: [
          { id: 'E01', name: '웃는표정' },
          { id: 'E02', name: '윙크' },
          { id: 'E03', name: '화난표정' },
          { id: 'E04', name: '슬픈표정' },
          { id: 'E05', name: '하트표정' },
        ],
        available_wmotions: [
          { id: 'W01', name: '표창' },
          { id: 'W02', name: '단검' },
        ],
      },
      {
        gc_id: '550e8400-e29b-41d4-a716-446655440001',
        world_name: '루나',
        character_name: '불꽃마법사',
        character_class: '아크메이지(불,독)',
        character_level: 205,
        character_image_url:
          'https://nxsvc.inface.nexon.com/maplestory/character/look/OBOLONDJFCFHJLABIBOFNCEDAHLNKEAOCAGNDCKHBJHGAHOLEIJEJEFPDHJOEBJJDCNFACAJKDGCDAPDIKLBPPDNCCPLFPFCPOHPEBMANEHEIIPNHJMPHMLOMGMAOFPFKMDDLDMMDJADPMDKLPECOKIFDKAAMDKALGGFALJNPOGLPJBOKNIIANIJFEMPILLMNEFNCAAPCHAGDLLJDHLGPBIOPDOABECEJPNNBFEHPNDGMHDBABFIDEKPMMFOOBMK?width=300&height=300',
        character_image_foot_position_y: 193,
        collabo_item_names: ['귀멸의 칼날 무이치로 헤어'],
        available_actions: [
          { id: 'A01', name: '걷기' },
          { id: 'A02', name: '달리기' },
          { id: 'A03', name: '점프' },
          { id: 'A04', name: '앉기' },
          { id: 'A06', name: '날기' },
        ],
        available_emotions: [
          { id: 'E01', name: '웃는표정' },
          { id: 'E04', name: '졸린표정' },
          { id: 'E05', name: '하트표정' },
          { id: 'E06', name: '울먹표정' },
          { id: 'E07', name: '반짝표정' },
        ],
        available_wmotions: [{ id: 'W03', name: '스태프' }],
      },
      {
        gc_id: '550e8400-e29b-41d4-a716-446655440002',
        world_name: '베라',
        character_name: '궁수마스터',
        character_class: '신궁',
        character_level: 228,
        character_image_url:
          'https://nxsvc.inface.nexon.com/maplestory/character/look/EDLCJHAOIHABFEHJEDNBHCHICOEHKJICJKKIHFLFLLEJOALEEAHELJMIKCHDACKOJIMOCFGGCGHKPBFACOCJFFIIOMKIHHCBFGPJGHBJBECDNIMJEFPMBIAJFDILHEPGHOIEGKFCOAOECDFGBEHCNPJBFMNHOFLLFHNAEBFKGFCMGKJJHJLMBPEIFHOAIOEGIEBHGGNBMBCLNNMMEHCNBMHGNOOJGGLKFOOBHHOKCFMOLCPONJDJNMDPKPDDFPFA?width=300&height=300',
        character_image_foot_position_y: 375,
        collabo_item_names: ['BT21 TATA 모자', '메이플 아케인 세트'],
        available_actions: [
          { id: 'A01', name: '걷기' },
          { id: 'A02', name: '달리기' },
          { id: 'A03', name: '점프' },
          { id: 'A04', name: '앉기' },
          { id: 'A17', name: '활시위당기기' },
        ],
        available_emotions: [
          { id: 'E01', name: '웃는표정' },
          { id: 'E31', name: '집중표정' },
          { id: 'E32', name: '날카로운표정' },
          { id: 'E33', name: '결의표정' },
          { id: 'E34', name: '승리표정' },
        ],
        available_wmotions: [{ id: 'W10', name: '활' }],
      },
      {
        gc_id: '550e8400-e29b-41d4-a716-446655440016',
        world_name: '크로아',
        character_name: '마법사제왕',
        character_class: '아크메이지(썬,콜)',
        character_level: 235,
        character_image_url:
          'https://nxsvc.inface.nexon.com/maplestory/character/look/MFMHDFCLLGELHHFGHCMOCDDOBIFBBIKKGCNECONHJFGIADDMNFDIDOFFGMGEPBIIBLBEDCKAAJIKLKKMAOPEOLPKPBINFFNJBPLLDGFPMFDCCCCKNHOFCOBLPJDKBBEEEGKIEAMELFKBDDKMJIMAJPHMIHKHGLDKIFNIKABOPKBFKKNICNHOIIJOKKADPNPOEIPCOGCCGHCPHGFLDNGBCPABNDABOEFMIKHJGHOEPFFONLAHIFBMBJBMPKEGIABD?width=300&height=300',
        character_image_foot_position_y: 370,
        collabo_item_names: ['메이플 아케인 세트', '카카오프렌즈 망토'],
        available_actions: [
          { id: 'A01', name: '걷기' },
          { id: 'A02', name: '달리기' },
          { id: 'A03', name: '점프' },
          { id: 'A18', name: '텔레포트' },
          { id: 'A19', name: '마법진' },
        ],
        available_emotions: [
          { id: 'E01', name: '웃는표정' },
          { id: 'E35', name: '마법표정' },
          { id: 'E36', name: '신비표정' },
          { id: 'E37', name: '지혜표정' },
          { id: 'E38', name: '초월표정' },
        ],
        available_wmotions: [{ id: 'W11', name: '스태프' }],
      },
      {
        gc_id: '550e8400-e29b-41d4-a716-446655440017',
        world_name: '아케인',
        character_name: '전사신',
        character_class: '팔라딘',
        character_level: 232,
        character_image_url:
          'https://nxsvc.inface.nexon.com/maplestory/character/look/IOGEDDENGGMPAFGJBCEPBAMECBJHODDLOAALAOKOPJJPMKLLDAADINKAEIPJAAJDBLAKDKNMCGCMDIOIJMEOFCOBMHGDJODLCHIJCAFHLKDKNKIHDIAIDGILFHNPCLFGDIDIHGEKPDAFCHNGCFAFFDEKJCCFHDOMPIEAHCFEIHDBFPIIEDCCJMFDGEKHEPCIHDGIHJMCDKLKNBPKHEFNLJDENEIMHHALAAJILIMJEJOJKABLELLGGJDPMIGNFCAD?width=300&height=300',
        character_image_foot_position_y: 380,
        collabo_item_names: ['메이플 아케인 세트', 'BT21 CHIMMY 모자'],
        available_actions: [
          { id: 'A01', name: '걷기' },
          { id: 'A02', name: '달리기' },
          { id: 'A03', name: '점프' },
          { id: 'A20', name: '방패막기' },
          { id: 'A21', name: '돌진' },
        ],
        available_emotions: [
          { id: 'E01', name: '웃는표정' },
          { id: 'E39', name: '용맹표정' },
          { id: 'E40', name: '결의표정' },
          { id: 'E41', name: '정의표정' },
          { id: 'E42', name: '승리표정' },
        ],
        available_wmotions: [
          { id: 'W12', name: '한손검' },
          { id: 'W13', name: '방패' },
        ],
      },
    ],
  },
  {
    guid: 87654321,
    last_login_at: 1679209200000, // 2023-03-18 12:00:00
    gc_list: [
      {
        gc_id: '550e8400-e29b-41d4-a716-446655440003',
        world_name: '엘리시움',
        character_name: '궁수신화',
        character_class: '보우마스터',
        character_level: 180,
        character_image_url:
          'https://nxsvc.inface.nexon.com/maplestory/character/look/OAOENEMIDJCEPINACNOCBAADBJBKKLJNKEDIFPAOFMHAJOFKDJIPDCAJPBOLDOHNOLCFIHDOJBJBMGLMCLFPNFENGOJPNGGPFMPHCBMLDFKACKIAEDMAENCDNMAFOJFJEODCFIKMFEGAMBKIMNJOOJGFEOFINLAONBNNEDEHMNKBDNMPJEDHNIGHDOLGPOKAEHFFHONLIDIOENDCBNBJPJFIHEBBDODAFDIBAHHFEAALGNLFPFKLHHKHKNGLDHJD?width=300&height=300',
        character_image_foot_position_y: 370,
        collabo_item_names: ['라인프렌즈 모자', '귀멸의 칼날 젠이츠 망토'],
        available_actions: [
          { id: 'A01', name: '걷기' },
          { id: 'A02', name: '달리기' },
          { id: 'A03', name: '점프' },
          { id: 'A04', name: '앉기' },
          { id: 'A07', name: '구르기' },
        ],
        available_emotions: [
          { id: 'E01', name: '웃는표정' },
          { id: 'E05', name: '놀란표정' },
          { id: 'E08', name: '화난표정' },
          { id: 'E09', name: '춤추는표정' },
          { id: 'E10', name: '졸린표정' },
        ],
        available_wmotions: [{ id: 'W04', name: '활' }],
      },
      {
        gc_id: '550e8400-e29b-41d4-a716-446655440000',
        world_name: '레드',
        character_name: '전사킹',
        character_class: '히어로',
        character_level: 195,
        character_image_url:
          'https://nxsvc.inface.nexon.com/maplestory/character/look/BLMNEHOELJGMIIIMHDCKCGMIMBBOBBBDIOFPAMGILAAMEEDKMBPOGGCGIMNLGFIGKEBFCKGIFOOFBLNJCAHJGJMLDKCNICJDEEPCHHHCABLLDBFLMHGPLMMGPOJNFLJEPNNMHBNAGMJDFDIMAPOLCNFOIENAGFBCHEJBECNEGOJJBAKOEAIMNDAGKKHMCEGEOLCEHCMOAIJGNBDCMENKMIKFBOFLAPFHAGMPKELPKKNKLKNAMBKHPPGEACLKMHHG?width=300&height=300',
        avatar_bottom_y: 193,
        collabo_item_names: [],
        available_actions: [
          { id: 'A01', name: '걷기' },
          { id: 'A02', name: '달리기' },
          { id: 'A03', name: '점프' },
          { id: 'A04', name: '앉기' },
          { id: 'A08', name: '돌진' },
        ],
        available_emotions: [
          { id: 'E01', name: '웃는표정' },
          { id: 'E11', name: '도발표정' },
          { id: 'E12', name: '긴장표정' },
          { id: 'E13', name: '기합표정' },
          { id: 'E14', name: '승리표정' },
        ],
        available_wmotions: [{ id: 'W05', name: '대검' }],
      },
      {
        gc_id: '550e8400-e29b-41d4-a716-446655440005',
        world_name: '오리온',
        character_name: '도적왕',
        character_class: '섀도어',
        character_level: 198,
        character_image_url:
          'https://nxsvc.inface.nexon.com/maplestory/character/look/GMCBPALEAOJAOKKBMNNCDMIOBEGDFDOCIDENEDNNCOBNMLANONALLHBPAKOBCMKACAHEMMIHAAAIAOFINKJKFPJBCFALEFFNIALBOGBFDHLGIOIEBAODIDKNFAGOOCBBBKFAEBBEHKODJMGDDEMACNLJLMLKBKEILCKBOPLFHAEPLNNKLOGDDIFIAMLAEDANDHMNMHEFBHHNBLHMEJKHDHHGLGPNAGIIBJHCNCCGOPDDLHNCBMGOLNBOCFOGNJLJ?width=300&height=300',
        avatar_bottom_y: 193,
        collabo_item_names: [],
        available_actions: [
          { id: 'A01', name: '걷기' },
          { id: 'A02', name: '달리기' },
          { id: 'A03', name: '점프' },
          { id: 'A09', name: '은신' },
          { id: 'A10', name: '텔레포트' },
        ],
        available_emotions: [
          { id: 'E01', name: '웃는표정' },
          { id: 'E15', name: '냉소표정' },
          { id: 'E16', name: '비웃는표정' },
          { id: 'E17', name: '음흉한표정' },
          { id: 'E18', name: '침착표정' },
        ],
        available_wmotions: [{ id: 'W06', name: '단도' }],
      },
      {
        gc_id: '550e8400-e29b-41d4-a716-446655440006',
        world_name: '유니온',
        character_name: '마법사장인',
        character_class: '비숍',
        character_level: 225,
        character_image_url:
          'https://nxsvc.inface.nexon.com/maplestory/character/look/GEMMGGOJJBAAOKFMBIGMFIPEHPFNBNPGMLCHALGIBPLOIPCCBFJLFDBDJGBNKKPBCOCDILPGPKIKLOIBCNPNHFGOMGFPBKKENPBDGNDLGHLDIEGFENFJHECCKGNNMOFAKFFMFDHNDGOIKHGHAGJCPFLIACMBGGCPMJKDAEMPCHEOGPLJAFMMBAJDJGAHNGFDLMLACAPPKEJIPMMMOBOOKMAKJGJHJNKJIMKANNIIHMOGNLHNGPKFDCKBLAIJNDJC?width=300&height=300',
        avatar_bottom_y: 193,
        collabo_item_names: [],
        available_actions: [
          { id: 'A01', name: '걷기' },
          { id: 'A02', name: '달리기' },
          { id: 'A03', name: '점프' },
          { id: 'A11', name: '순간이동' },
          { id: 'A12', name: '부활' },
        ],
        available_emotions: [
          { id: 'E01', name: '웃는표정' },
          { id: 'E19', name: '기도표정' },
          { id: 'E20', name: '축복표정' },
          { id: 'E21', name: '명상표정' },
          { id: 'E22', name: '치유표정' },
        ],
        available_wmotions: [{ id: 'W07', name: '완드' }],
      },
      {
        gc_id: '550e8400-e29b-41d4-a716-446655440007',
        world_name: '스카니아',
        character_name: '해적신',
        character_class: '바이퍼',
        character_level: 215,
        character_image_url:
          'https://nxsvc.inface.nexon.com/maplestory/character/look/HCAJOBFOEHOAFHDMMDHOEBKODDBNJDMCHHNNOCABLJHMHHFNFDBNJIFILJMGONBPPELIOJLOOGPACDFIBKCJGEIHOHLPKMKHHCMCLIJFIGBJGOFHINFFGAGCJFCELGBJIOAHEOHLOFHKBLEBFBEHCFABHHABMIIFALNLHLPINKHJCDIFFFNCHBKILDEKKFHANOJCOHNIHBOADHLFGPDNLIDEIPINGPOIBPKLMOAIEODCFPHBANBIMPKMPHJJPJPN?width=300&height=300',
        avatar_bottom_y: 193,
        collabo_item_names: [],
        available_actions: [
          { id: 'A01', name: '걷기' },
          { id: 'A02', name: '달리기' },
          { id: 'A03', name: '점프' },
          { id: 'A13', name: '회전킥' },
          { id: 'A14', name: '연타' },
        ],
        available_emotions: [
          { id: 'E01', name: '웃는표정' },
          { id: 'E23', name: '격투표정' },
          { id: 'E24', name: '도발표정' },
          { id: 'E25', name: '결의표정' },
          { id: 'E26', name: '필살표정' },
        ],
        available_wmotions: [{ id: 'W08', name: '너클' }],
      },
      {
        gc_id: '550e8400-e29b-41d4-a716-446655440008',
        world_name: '루나',
        character_name: '궁수제왕',
        character_class: '패스파인더',
        character_level: 220,
        character_image_url:
          'https://nxsvc.inface.nexon.com/maplestory/character/look/MANLMMLFFMPLJMCEKPMHHLOFICMGGJBLHLHAOBMADIDJBCHNKONJBMPJGAMENEFGGNFAGOMFLIAFCHBPCIDFFPGNOKGNMCPOACLFMCEGJAMBNPAAGFLKJKIGPDPCLLHINNJBPBKKOMJJPLCFPOJFPHPIBHCCEMJEIGOELFDHFEHLKEHBPGCMIENCFANOFHKEDPHGLAOHLCIBAKJNOLBBJOLCOEMDIDAPINGDMNLGJDFJIBMFJHCCDGPCAJIALJIA?width=300&height=300',
        avatar_bottom_y: 193,
        collabo_item_names: [],
        available_actions: [
          { id: 'A01', name: '걷기' },
          { id: 'A02', name: '달리기' },
          { id: 'A03', name: '점프' },
          { id: 'A15', name: '구르기' },
          { id: 'A16', name: '표식' },
        ],
        available_emotions: [
          { id: 'E01', name: '웃는표정' },
          { id: 'E27', name: '탐색표정' },
          { id: 'E28', name: '관찰표정' },
          { id: 'E29', name: '집중표정' },
          { id: 'E30', name: '조준표정' },
        ],
        available_wmotions: [{ id: 'W09', name: '에인션트보우' }],
      },
      {
        gc_id: '550e8400-e29b-41d4-a716-446655440009',
        world_name: '엘리시움',
        character_name: '마법사왕',
        character_class: '아크메이지(불,독)',
        character_level: 225,
        character_image_url:
          'https://nxsvc.inface.nexon.com/maplestory/character/look/HAJLJFANLMPDIPAOKFBINDMEJIHNLDAIKGDEDGDPACJNMIMBOBJDBMBJPEGMOHOABLILHECMHHJLBMMNOHOGFNHMOGJEONFKDJLAONJODOBOGHKDOKJNMFAHLAKNJIMMJLDGDOAFADDLFCGEINCKMNLHELCMPAKPJGEOGJOGBDIBIAGACHNMFBGPOPIHBEOPCFMGCFHCJIOFFFDPHGKEIOIEIMIKJAOCGBDMDLEAJKCMDMJCABEEIFHJEOGAINJJ?width=300&height=300',
        avatar_bottom_y: 193,
        collabo_item_names: [],
        available_actions: [
          { id: 'A01', name: '걷기' },
          { id: 'A02', name: '달리기' },
          { id: 'A03', name: '점프' },
          { id: 'A17', name: '마법진' },
          { id: 'A18', name: '주문' },
        ],
        available_emotions: [
          { id: 'E01', name: '웃는표정' },
          { id: 'E31', name: '마법표정' },
          { id: 'E32', name: '주문표정' },
          { id: 'E33', name: '명상표정' },
          { id: 'E34', name: '집중표정' },
        ],
        available_wmotions: [{ id: 'W10', name: '완드' }],
      },
      {
        gc_id: '550e8400-e29b-41d4-a716-446655440010',
        world_name: '크로아',
        character_name: '전사신',
        character_class: '히어로',
        character_level: 230,
        character_image_url:
          'https://nxsvc.inface.nexon.com/maplestory/character/look/HAPBOFLMGGPBBCDFBDOMLKBKHMAOPAIEPIOOOKIDOEBOKJNEJOOMKPCMHDKJJOJEGMAMIKDHFMLPOKMCNIEHNBNLIINGPAPJDELKDPDGIJNGDFKGJOJIJLGDGHAOCHMFOMEPEMPAIGBLLMEAMABOJJLMAOKLCKFDPGGBPGGKAMLDHFMBHADNACFHJKJKAGLCPBLAAKPOPMDOJAICGLPLDBLEOEFFEGIHNJKNBFODDAJPIHBDDLEFBAOLPBPFNJEI?width=300&height=300',
        avatar_bottom_y: 193,
        collabo_item_names: [],
        available_actions: [
          { id: 'A01', name: '걷기' },
          { id: 'A02', name: '달리기' },
          { id: 'A03', name: '점프' },
          { id: 'A19', name: '베기' },
          { id: 'A20', name: '찌르기' },
        ],
        available_emotions: [
          { id: 'E01', name: '웃는표정' },
          { id: 'E35', name: '전투표정' },
          { id: 'E36', name: '분노표정' },
          { id: 'E37', name: '승리표정' },
          { id: 'E38', name: '도전표정' },
        ],
        available_wmotions: [{ id: 'W11', name: '투핸드소드' }],
      },
      {
        gc_id: '550e8400-e29b-41d4-a716-446655440011',
        world_name: '베라',
        character_name: '도적왕',
        character_class: '나이트로드',
        character_level: 228,
        character_image_url:
          'https://nxsvc.inface.nexon.com/maplestory/character/look/HEAOPHGPLLFIIJMFCHEDNLLIINCFCGGFOMGFHEIEJOKBAFLCMHFDPJINOKEIAPLCBFGDGLABLEKHKPBLAANFBOABDIGKCPCPGFDIBGMDHPFEFPGGHCBOGLFLGLKBCDPLAHPLPIBPKMEGGHJKLODBDEGPKAPBAGGKPMMEKPBLDFHNDFHDJBHNCKFGNPOFJJCOMMOKCIJGIMGPOKBHBMHCBNPMGGFBFKPNHLAGAOADCIFCLCDGPJOCMBIPHIDPMGAE?width=300&height=300',
        avatar_bottom_y: 193,
        collabo_item_names: [],
        available_actions: [
          { id: 'A01', name: '걷기' },
          { id: 'A02', name: '달리기' },
          { id: 'A03', name: '점프' },
          { id: 'A21', name: '암살' },
          { id: 'A22', name: '은신' },
        ],
        available_emotions: [
          { id: 'E01', name: '웃는표정' },
          { id: 'E39', name: '암살표정' },
          { id: 'E40', name: '은밀표정' },
          { id: 'E41', name: '경계표정' },
          { id: 'E42', name: '잠행표정' },
        ],
        available_wmotions: [{ id: 'W12', name: '표창' }],
      },
      {
        gc_id: '550e8400-e29b-41d4-a716-446655440012',
        world_name: '아케인',
        character_name: '해적왕',
        character_class: '캡틴',
        character_level: 223,
        character_image_url:
          'https://nxsvc.inface.nexon.com/maplestory/character/look/OEPBCINBMFBJKGEBMHEOEEAFDIKJGDHIPHFKKIJPBKFGCDLLIANGJNKFKGBFBIPNELKJECFDDAKANKACOJDILJDFHOMPMODKEIDNFHHFNMHKMFCLAOMIMAFMNBMOJMMADAKODMFFJODCFBNAOCAIEHDGMNHLNAJKDIJABKBPLFFOCCNDPNCCENMMGHFFMCPADGOFMEFIMPAOKIJDKNKDHMGPPHHIMHEFJNJPDGPADMEHGBJPKMBNAKFGAJCCLLCD?width=300&height=300',
        avatar_bottom_y: 193,
        collabo_item_names: [],
        available_actions: [
          { id: 'A01', name: '걷기' },
          { id: 'A02', name: '달리기' },
          { id: 'A03', name: '점프' },
          { id: 'A23', name: '사격' },
          { id: 'A24', name: '돌진' },
        ],
        available_emotions: [
          { id: 'E01', name: '웃는표정' },
          { id: 'E43', name: '해적표정' },
          { id: 'E44', name: '사격표정' },
          { id: 'E45', name: '돌격표정' },
          { id: 'E46', name: '승리표정' },
        ],
        available_wmotions: [{ id: 'W13', name: '건' }],
      },
      {
        gc_id: '550e8400-e29b-41d4-a716-446655440013',
        world_name: '노바',
        character_name: '궁수신',
        character_class: '보우마스터',
        character_level: 227,
        character_image_url:
          'https://nxsvc.inface.nexon.com/maplestory/character/look/BAEGDFAEDCNHNCLOCADHCFBLIBACPAMHFGNNGFNDKHKPEIBIIPBHPKEAOOPPBDAJKCMOHNIKLNOFDCAMPPMPHJKOHOJHMODPCKHPAFHGHEJGLFFKNDPCHCHNENDHANJCFCIAMKACGOEFOCCJFJIANEOJKDHGEGJLDEKJBPLFLLGAMBEPEPEDBEIKLOCMOPGBIDELMCEMNPCFANOLOFHKDFJPKHMPIJDDCFLJIMFFLLFFBDOPCLEBEGODEGBEEPHO?width=300&height=300',
        avatar_bottom_y: 193,
        collabo_item_names: [],
        available_actions: [
          { id: 'A01', name: '걷기' },
          { id: 'A02', name: '달리기' },
          { id: 'A03', name: '점프' },
          { id: 'A25', name: '조준' },
          { id: 'A26', name: '회피' },
        ],
        available_emotions: [
          { id: 'E01', name: '웃는표정' },
          { id: 'E47', name: '명중표정' },
          { id: 'E48', name: '조준표정' },
          { id: 'E49', name: '사냥표정' },
          { id: 'E50', name: '승리표정' },
        ],
        available_wmotions: [{ id: 'W14', name: '보우' }],
      },
      {
        gc_id: '550e8400-e29b-41d4-a716-446655440014',
        world_name: '스카니아',
        character_name: '도적신',
        character_class: '나이트로드',
        character_level: 225,
        character_image_url:
          'https://nxsvc.inface.nexon.com/maplestory/character/look/FDHLMENJPFAOGFPANMMNPMICIKPBOFACBJKIFACPNGDMNIHCJDFFPNNOHEPBELJMBKKECFHGAIMBHBPFOMLHCEKONBHODJECGDMLGPIFBNNIGKPNDMGBDKJOLCNJJDMAJHJKJNNLGOHFBHOMOAEFPEONLHDHDNANENKHGDHIMAEEIBIOELMGBIPKIKODKKHHEFLDBGEKIHABNJNPNHJNAOEPFPJGNEEKECOFEEDBJHHEJLENOPMFBFHFLBPEBFNC?width=300&height=300',
        avatar_bottom_y: 193,
        collabo_item_names: [],
        available_actions: [
          { id: 'A01', name: '걷기' },
          { id: 'A02', name: '달리기' },
          { id: 'A03', name: '점프' },
          { id: 'A27', name: '암살' },
          { id: 'A28', name: '은신' },
        ],
        available_emotions: [
          { id: 'E01', name: '웃는표정' },
          { id: 'E51', name: '암살표정' },
          { id: 'E52', name: '은신표정' },
          { id: 'E53', name: '그림자표정' },
          { id: 'E54', name: '승리표정' },
        ],
        available_wmotions: [{ id: 'W15', name: '표창' }],
      },
      {
        gc_id: '550e8400-e29b-41d4-a716-446655440015',
        world_name: '루나',
        character_name: '마법신',
        character_class: '아크메이지(불,독)',
        character_level: 229,
        character_image_url:
          'https://nxsvc.inface.nexon.com/maplestory/character/look/MLLHBPKDJLBPKOBDONMBHNIACLADIFFPJDJBBGBIHABDIKODJDCBLFOFEKNHLKBMEHFHAKDGMHBDPFIFAGJLHMPAAEPGFLCIICGOJCLIHLGHKFLBCDEEKDLCAMFKMCLJGJBDAEGJLANMKCFKAAGEEEIOFPCOKEJEIJIAFOLBMFDKMAMBLLBCJPEKFIHEMHDBKIMPBCALELHOAHGJBELHMJDJGAHPHCJPMANBFHJNLIKAGFCIGJMLKCOLOAIMLNCP?width=300&height=300',
        avatar_bottom_y: 193,
        collabo_item_names: [],
        available_actions: [
          { id: 'A01', name: '걷기' },
          { id: 'A02', name: '달리기' },
          { id: 'A03', name: '점프' },
          { id: 'A29', name: '마법발사' },
          { id: 'A30', name: '텔레포트' },
        ],
        available_emotions: [
          { id: 'E01', name: '웃는표정' },
          { id: 'E55', name: '마법표정' },
          { id: 'E56', name: '불꽃표정' },
          { id: 'E57', name: '독기표정' },
          { id: 'E58', name: '승리표정' },
        ],
        available_wmotions: [{ id: 'W16', name: '스태프' }],
      },
    ],
  },
];

export const PF2_MOCK_DATA = [
  {
    designs: [
      {
        _data: {
          user_custom_property_mapping_path: {
            id: '5',
            text: '캐릭터이미지',
            value: "gc_list[{gc_id: '${gc_id}'}]->character_image_url",
          },
        },
      },
      {
        _data: {
          user_custom_property_mapping_path: {
            id: '1',
            text: '월드이름',
            value: "gc_list[{gc_id: '${gc_id}'}]->world_name",
          },
        },
      },
      {
        _data: {
          user_custom_property_mapping_path: {
            id: '2',
            text: '캐릭터이름',
            value: "gc_list[{gc_id: '${gc_id}'}]->character_name",
          },
        },
      },
      {
        _data: {
          user_custom_property_mapping_path: {
            id: '3',
            text: '캐릭터직업',
            value: "gc_list[{gc_id: '${gc_id}'}]->character_class",
          },
        },
      },
      {
        _data: {
          user_custom_property_mapping_path: {
            id: '4',
            text: '캐릭터레벨',
            value: "gc_list[{gc_id: '${gc_id}'}]->character_level",
          },
        },
      },
    ],
  },
];
